import axiosInstance from '../axios/axiosInstance';
import { Exam, Page } from '../model/response';
import { ExamImportRequest } from '../model/request';

export const pagePractices = async (params: any) => {
  const { data } = await axiosInstance.get<Page<Exam>>('practices/page', { params });
  return data;
};

export const findAllPractices = async (subjectId?: string) => {
  const { data } = await axiosInstance.get<Exam[]>('practices', { params: { subjectId, fromCMS: true } });
  return data;
};

export const getFullPracticeDetail = async (practiceId: string) => {
  const { data } = await axiosInstance.get<ExamImportRequest>(`practices/${practiceId}:get-full-detail`);
  return data;
};

export const hasDeletePracticeConfirm = async (practiceId: string) => {
  const { data } = await axiosInstance.get<boolean>(`practices/${practiceId}/has-delete-confirm`);
  return data;
};

export const deletePractice = async (practiceId: string) => {
  await axiosInstance.delete(`practices/${practiceId}`);
};
